import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
interface ArticleCardProps {
  title: string;
  publisher: string;
  description?: string;
  url: string;
  logoUrl?: string;
  imageUrl?: string;
  category?: string;
}
export function ArticleCard({
  title,
  publisher,
  description,
  url,
  logoUrl,
  imageUrl,
  category
}: ArticleCardProps) {
  return <div className="bg-white rounded-lg shadow-md luxury-border hover:shadow-lg transition-all duration-300 group p-8 flex flex-col h-full transform hover:-translate-y-1 elegant-card" data-id="element-39">
      <div className="flex items-center mb-4" data-id="element-40">
        <div className="w-10 h-10 gold-gradient rounded-full flex items-center justify-center mr-3" data-id="element-41">
          <span className="text-xs font-bold text-white" data-id="element-42">
            {publisher.charAt(0)}
          </span>
        </div>
        <div className="flex flex-col" data-id="element-43">
          <span className="text-sm font-medium text-gray-500" data-id="element-44">{publisher}</span>
          {category && <span className="text-xs accent-color" data-id="element-45">{category}</span>}
        </div>
      </div>
      <h3 className="text-xl font-bold mb-3 group-hover:accent-color transition-colors" data-id="element-46">
        {title}
      </h3>
      {description && <p className="text-gray-700 mb-4 flex-grow leading-relaxed" data-id="element-47">
          {description}
        </p>}
      <a href={url} target="_blank" rel="noopener noreferrer" className="mt-auto inline-flex items-center text-gray-900 font-medium hover:accent-color transition-colors elegant-button" data-id="element-48">
        <span data-id="element-49">Read article</span>
        <ExternalLinkIcon size={16} className="ml-1 group-hover:ml-2 transition-all" data-id="element-50" />
      </a>
    </div>;
}